import React from 'react';
import { Button, ButtonProps } from '@material-ui/core';
import { useStyles } from './ButtonSecondaryLightStyles';
import clsx from 'clsx';

interface IButtonSecondaryLight extends ButtonProps {
  loading?: boolean;
  rootBtnClass: string;
  loadingBtnClass: string;
  loadingAnimationClass: string;
}

export const ButtonSecondaryLight: React.FC<IButtonSecondaryLight> = ({
  rootBtnClass,
  loadingBtnClass,
  loadingAnimationClass,
  disabled,
  className,
  loading,
  children,
  ...rest
}: IButtonSecondaryLight): JSX.Element => {
  const classes = useStyles();
  if (loading) {
    return (
      <Button className={clsx(rootBtnClass, className, loadingBtnClass)} {...rest} disabled>
        <div className={loadingAnimationClass}></div>
      </Button>
    );
  } else {
    return (
      <Button className={clsx(rootBtnClass, classes.btnSecondaryLight, className)} disabled={disabled} {...rest}>
        {children}
      </Button>
    );
  }
};

export default ButtonSecondaryLight;
